import { Capacitor } from "@capacitor/core";
import { Platform } from "@cosine/lib/utils/system/detectPlatform.types";

export function detectPlatform (): Platform {
  return Capacitor.isNativePlatform() ? Platform.MobileNative : Platform.Web;
}
